// ---------------------------------------------------------------------------
// Web3Forms — direct form-to-email without a backend.
//
// SETUP (one time, 30 seconds):
//   1. Go to https://web3forms.com → enter the inbox you want to receive at
//      (e.g. cognitics.research@gmail.com).
//   2. You'll get an access key emailed to you.
//   3. Paste that key into WEB3FORMS_ACCESS_KEY below.
//
// Once the key is in, every contact + early-access form on the site sends
// straight to that inbox — no Gmail tab, no client redirect, just an inline
// success state.
// ---------------------------------------------------------------------------

const WEB3FORMS_ACCESS_KEY = 'da4011f4-0a9c-486b-a71d-efda4d4c1e60';

const ENDPOINT = 'https://api.web3forms.com/submit';

/**
 * Send a form submission to the configured inbox.
 * @param {{ subject: string, fields: Record<string, string|number|undefined> }} args
 * @returns {Promise<{ ok: boolean, message: string }>}
 */
export async function sendForm({ subject, fields }) {
  if (!WEB3FORMS_ACCESS_KEY || WEB3FORMS_ACCESS_KEY.startsWith('YOUR_')) {
    return {
      ok: false,
      message:
        'Email is not configured yet. Reach us directly at cognitics.research@gmail.com.',
    };
  }

  const payload = {
    access_key: WEB3FORMS_ACCESS_KEY,
    subject,
    from_name: 'Cognitics Website',
    ...fields,
  };

  try {
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => ({}));
    if (res.ok && data.success) {
      return { ok: true, message: 'Thanks — we received your message.' };
    }
    return {
      ok: false,
      message: data.message || 'Something went wrong. Please try again or email us directly.',
    };
  } catch (err) {
    return {
      ok: false,
      message: 'Network error. Please try again or email us directly.',
    };
  }
}
